import React from "react";
import {
  Divider,
  List,
  ListItemText,
  ListSubheader,
  ListItemIcon,
  Box,
  CircularProgress,
  ListItemButton,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";
import useStyles, { StyledLink } from "./Styles";
import { useGetGenresQuery } from "../../services/TMDB";
import genreIcons from '../../assets/genres';
import {  useDispatch } from "react-redux";
import { selectGenreOrCategory } from "../../features/currentGenreOrCategory";
const categories = [
  { label: "Popular", value: "popular" },
  { label: "Top Rated", value: "top_rated" },
  { label: "upcoming", value: "upcoming" },
];

const redLogo =
  "https://fontmeme.com/permalink/210930/8531c658a743debe1e1aa1a2fc82006e.png";
const blueLogo =
  "https://fontmeme.com/permalink/210930/6854ae5c7f76597cf8680e48a2c8a50a.png";
const Sidebar = ({ setMobileOpen }) => {

  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { data, isFetching, error } = useGetGenresQuery();

  // useEffect(() => {
  //   setMobileOpen(false);
  // }, [user, genre])


  return (
    <>
      <Link to="/" className={classes.imageLink}>
        <img
          className={classes.image}
          src={theme.palette.mode === "light" ? redLogo : blueLogo}
          alt="Filmpire logo"
          srcset=""
        />
      </Link>

      <Divider />
      <List>
        <ListSubheader>Categgories</ListSubheader>
        {categories.map(({ label, value }) => (
          // <Link key={value} className={classes.links} to="/">
          <StyledLink onClick={() => dispatch(selectGenreOrCategory(value))}>
          <ListItemButton>
            <ListItemIcon>
                <img src={genreIcons[label.toLowerCase()]} className={classes.genreImage} height={30} alt='image of icon' />
              </ListItemIcon>

            <ListItemText primary={label}></ListItemText>
          {/* // </Link> */}
            </ListItemButton>
</StyledLink>
        ))}
      </List>
      <Divider />
      <List>
        <ListSubheader>Geners</ListSubheader>
        {isFetching ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress size='4rem'/>
          </Box>
        ):
          data.genres.map(({ name, id }) => (
            <StyledLink onClick={() => dispatch(selectGenreOrCategory(id))}>
          <ListItemButton>
           <ListItemIcon>
                  <img src={genreIcons[name.toLowerCase()]} className={classes.genreImage} alt='image of icon' height={30} />
                </ListItemIcon>

            <ListItemText primary={name}></ListItemText>
              </ListItemButton>
              </StyledLink>
        ))}
      </List>
    </>
  );
};

export default Sidebar;
